import apiClient from './index';
import {
  MobileNewsCreate,
  MobileNewsUpdate,
  MobileNewsListResponse,
  MobileNewsRead,
} from './types';

export const mobileNewsApi = {
  async list(limit = 50, offset = 0): Promise<MobileNewsListResponse> {
    const res = await apiClient.get<MobileNewsListResponse>('/admin/mobile/news', {
      params: { limit, offset },
    });
    return res.data;
  },

  async create(payload: MobileNewsCreate): Promise<MobileNewsRead> {
    const res = await apiClient.post<MobileNewsRead>('/admin/mobile/news', payload);
    return res.data;
  },

  async update(id: string, payload: MobileNewsUpdate): Promise<MobileNewsRead> {
    const res = await apiClient.put<MobileNewsRead>(`/admin/mobile/news/${id}`, payload);
    return res.data;
  },

  async publish(id: string): Promise<MobileNewsRead> {
    const res = await apiClient.post<MobileNewsRead>(`/admin/mobile/news/${id}/publish`);
    return res.data;
  },
};
